(() => {
  'use strict';

  const readFonds = () => {
    const source = document.querySelector('[data-mb-fonds-authors]');
    if (!source) return {};
    try { return JSON.parse(source.textContent); } catch (_error) { return {}; }
  };

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const compact = (value) => normalize(value).replace(/[^a-z0-9]+/g, '');

  const matchesCreatorName = (name, query) => {
    const normalizedName = normalize(name);
    const normalizedQuery = normalize(query);
    const compactQuery = compact(query);
    return normalizedName.includes(normalizedQuery) || (compactQuery.length >= 2 && compact(name).includes(compactQuery));
  };

  const readGroups = () => {
    const source = document.querySelector('[data-mb-discovery-groups]');
    if (!source) return { authors: {}, illustrators: {} };
    try { return JSON.parse(source.textContent); } catch (_error) { return { authors: {}, illustrators: {} }; }
  };

  const creatorSelection = (query) => {
    const needle = normalize(query);
    if (needle.length < 3) return null;
    const groups = readGroups();
    const matchingAuthors = Object.entries(groups.authors || {})
      .filter(([name]) => matchesCreatorName(name, query));
    const matchingIllustrators = Object.entries(groups.illustrators || {})
      .filter(([name]) => matchesCreatorName(name, query));
    if (!matchingAuthors.length && !matchingIllustrators.length) return null;

    const allowed = new Set();
    matchingAuthors.forEach(([, handles]) => (handles || []).forEach((handle) => allowed.add(handle)));
    matchingIllustrators.forEach(([, products]) => (products || []).forEach((product) => {
      if (product?.handle) allowed.add(product.handle);
    }));

    matchingAuthors.forEach(([, handles]) => {
      const authorHandles = new Set(handles || []);
      Object.entries(window.MatchBooxSeriesGroups || {}).forEach(([seriesHandle, members]) => {
        if (members.length && members.every((handle) => authorHandles.has(handle))) allowed.add(seriesHandle);
      });
    });
    return allowed;
  };

  const filterCreatorResults = () => {
    // Zoekpagina: alleen boekjes/series (productkaarten) tonen, geen blog- of paginaresultaten.
    const input = document.querySelector('#Search-In-Template');
    const query = input?.value || new URLSearchParams(window.location.search).get('q') || '';
    const searchGrid = document.querySelector('#product-grid > ul');
    if (!searchGrid) return;
    let visibleProductCount = 0;
    const mbNq = normalize(query);
    if (mbNq.includes('cadeaubon')) {
      const mbBon = searchGrid.querySelector(':scope > li a[href*="/products/matchboox-cadeaubon"]');
      if (mbBon && mbBon.closest('li')) searchGrid.prepend(mbBon.closest('li'));
    }
    if (mbNq.includes('nieuwsbrief') && !searchGrid.querySelector('[data-mb-quick-newsletter]')) {
      const mbLi = document.createElement('li');
      mbLi.className = 'grid__item';
      mbLi.setAttribute('data-mb-quick-newsletter', '');
      mbLi.innerHTML = '<div class="article-card-wrapper card-wrapper underline-links-hover"><div class="card card--card card--text ratio color-" style="--ratio-percent: 100%;"><div class="card__content"><div class="card__information"><h3 class="card__heading"><a href="/#matchboox-nieuwsbrief" class="full-unstyled-link">Nieuwsbrief</a></h3></div><div class="card__badge bottom left"><span class="badge color-">Inschrijven</span></div></div></div></div>';
      searchGrid.prepend(mbLi);
    }
    searchGrid.querySelectorAll(':scope > li').forEach((item) => {
      const card = item.querySelector('[data-mb-clean-product-card]');
      const mbHref = (item.querySelector('a[href]') || { getAttribute: () => '' }).getAttribute('href') || '';
      const mbKeep = !card && ((mbNq.includes('fondslijst') && mbHref.indexOf('/pages/fondslijst') === 0) || (mbNq.includes('bestelinformatie') && mbHref.indexOf('/pages/bestelinformatie') === 0) || item.hasAttribute('data-mb-quick-newsletter'));
      item.hidden = !card && !mbKeep;
      if (card || mbKeep) visibleProductCount += 1;
    });
    const hasMorePages = !!document.querySelector('#product-grid .pagination-wrapper .pagination__item');
    if (hasMorePages) return;
    const label = visibleProductCount === 1 ? 'resultaat' : 'resultaten';
    const status = document.querySelector('.template-search__header p[role="status"]');
    if (status) status.textContent = `${visibleProductCount} ${label} gevonden voor “${query.trim()}”`;
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((el) => { el.textContent = `${visibleProductCount} ${label}`; });
  };

  const enhance = (root = document) => {
    const fonds = readFonds();
    root.querySelectorAll?.('[data-mb-clean-product-card]').forEach((card) => {
      const handle = card.dataset.productHandle;
      const authors = Object.entries(fonds)
        .filter(([, handles]) => Array.isArray(handles) && handles.includes(handle))
        .map(([name]) => name);
      if (!authors.length && handle === 'exclusieve-ezels-serie') authors.push('Mensje van Keulen'); if (!authors.length && handle === 'the-fab-four-serie') authors.push('Eric J. Coolen');
      if (!authors.length) return;
      let caption = card.querySelector('[data-mb-clean-caption], .mb-clean-product-card__caption');
      if (!caption) {
        caption = document.createElement('span');
        caption.className = 'mb-clean-product-card__caption';
        (card.querySelector('.mb-clean-product-card__link') || card).appendChild(caption);
      }
      { const bobQ = /bob\s*polak/i.test(new URLSearchParams(window.location.search).get('q') || ''); const override = { 'maria-barnas-serie-1': 'Maria Barnas, Margje Kuyper', 'the-fab-four-serie': 'Eric J. Coolen', 'propria-cures-serie': 'Diverse auteurs', 'ischa-meijer-serie': 'Ischa Meijer, Katelijne Davids', 'f-bordewijk-serie': 'F. Bordewijk, Jet Nijkamp' }[handle]; const shown = authors.length > 1 && /serie/.test(handle) && !bobQ ? authors.filter((n) => n !== 'Bob Polak') : authors; caption.textContent = (!bobQ && override) || shown.join(', '); }
    });
    filterCreatorResults(root);
  };

  const start = () => {
    enhance();
    const predictive = document.querySelector('[data-predictive-search]');
    if (predictive) new MutationObserver(() => filterCreatorResults(predictive)).observe(predictive, { childList: true, subtree: true });
    document.querySelector('#Search-In-Template')?.addEventListener('input', () => {
      window.setTimeout(() => filterCreatorResults(document), 0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('matchboox:clean-cards', (event) => enhance(event.detail?.root || document));
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
